import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

/** The standing link to the full source registry, shown wherever a page lists its own sources. */
export const SourcesLink = ({ testId = "sources-and-method-link", className = "" }) => (
  <Link
    to="/sources"
    data-testid={testId}
    className={`mono mt-5 inline-flex items-center gap-1.5 text-[0.6rem] uppercase tracking-[0.16em] text-ochre underline decoration-maasai underline-offset-4 hover:text-white ${className}`}
  >
    Sources and Method — every number, and when it was last read <ArrowUpRight size={11} />
  </Link>
);
